export default __webpack_public_path__ + "locales/zh-CN/About.json?hash=fa379638d4004653d6bb04623d07063f";